/**
 * Created by lzq on 2019/3/21.
 */
import React from 'react';
import { Row, Layout, Tabs, Icon, Modal, Checkbox, Form, Input, Button, Radio, message, } from 'antd';
import QRcode from 'qrcode-react';
import Server from '../applications/server/server';
import Store from '../applications/stores/store';
import './login.css'
import { BASE_URL, manageConfig, LOGIN_URL } from '../common/url';
import { Util } from '../common/util';
import Observer from '../applications/stores/observer';

const { Content, Footer } = Layout;
const TabPane = Tabs.TabPane;
const { confirm } = Modal;
const FormItem = Form.Item;

class DownloadManage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            token: `${Number(Observer.platformType)==1?'webManage':'pcCrp'}${Util.randomWord(false, 32)}`,        //token
            scanCodeStatus: false,                                  //扫码状态
            platformType: Observer.platformType ? Observer.platformType : '2',//1GCRP  2CRP
            tabNumber: 0,                                           //点击底部标题次数
            isTab: Observer.isTab ? Observer.isTab : 2,             //是否却换本地 1是 2否
            isCheckReport: true,
            search: props.location.search,  // url参数
            isNew: 0,                                               // 1新平台跳转过来 0否
            loginType: 'scan',                                      //默认优先使用微信扫码 password账号密码 scan微信扫码
            authType: 1,                                            //1手机号 2邮箱，GCRP仅支持手机号
            submitting: false,                                      //账号密码登录请求中
        }
    }

    /**
     * 进入页面加载一次
     */
    componentWillMount() {

        let token = `${Number(Observer.platformType) == 1 ? 'webManage' : 'pcCrp'}${Util.randomWord(false, 32)}`;
        this.setState(( token )=>{
            // X分钟未扫码就超时
            this.loginScroll();
        })
        sessionStorage.clear();  //清除所有本地缓存
        Store.removeListener('_scanPolling', this.refreshScanPolling);
        Store.removeListener('_passwordLogin', this.refreshPasswordLogin);
        document.title=`${manageConfig.groupName}-运营管理平台`
    }

    /**
     * 数据变更是加载
     */
    componentDidMount() {
        // 获取浏览器链接上的参数
        const searchParams = new URLSearchParams(window.location.search);
        // 获取特定参数的值
        const paramValue = searchParams.get('isNew');
        console.log(paramValue);
        this.setState({ isNew: paramValue });

        Store.on('_scanPolling', this.refreshScanPolling);
        Store.on('_passwordLogin', this.refreshPasswordLogin);
    }

    /**
     * 在页面卸载前调用
     */
    componentWillUnmount() {
        clearInterval(this.interval);
        Store.removeListener('_scanPolling', this.refreshScanPolling);
        Store.removeListener('_passwordLogin', this.refreshPasswordLogin);
    }

    /**
     * 轮询扫码
     */
    refreshScanPolling = () => {
        const result = Store._returnScanPolling();
        if(result.errCode == 0) {
            clearInterval(this.interval);
            // jumpType  0无指定页面 2扫码上传 3资源管理器
            let jumpType = result.detail.jumpType ? result.detail.jumpType : 0;
            console.log(this.state.platformType==1 ,this.state.isCheckReport)
            if (this.state.platformType==1 && this.state.isCheckReport) {
                return this.jumpToReport(this.state.token);
            }
            this.jumpToManage(this.state.token, jumpType);
        }
        if(result.errCode == 2) {
            this.setState({
                scanCodeStatus: true
            });
        }
    }

    /**
     * 登录成功后跳转集团数据报表
     */
    jumpToReport = (token) => {
        window.location.href = `${this.state.isTab==2?`${LOGIN_URL}/data_report/#/main`:'http://localhost:3000/'}?token=${token}&isType=3`;
    }

    /**
     * 登录成功后跳转管理平台
     */
    jumpToManage = (token, jumpType) => {
        if(this.state.isTab == 1){
            window.location.href = `http://localhost:3000/?token=${token}&isTab=${this.state.isTab}&jumpType=${jumpType}`;
        }else{
            window.location.href = `${LOGIN_URL}/${this.state.platformType==1?'gcrp_manage':'crp_manage'}/?token=${token}&isTab=${this.state.isTab}&jumpType=${jumpType}`;
        }
    }

    /**
     * 账号密码登录结果
     */
    refreshPasswordLogin = () => {
        const result = Store._returnPasswordLogin();
        this.setState({ submitting: false });
        if(result.errCode != 0) {
            message.error(result.errMsg || '登录失败，请稍后重试');
            return;
        }
        // GCRP 返回 detail，CRP 返回 data
        const detail = result.detail || result.data || {};
        const token = detail.scanToken || this.state.token;
        message.success(`欢迎「${detail.nickname || ''}」登录~`);
        if(this.state.platformType==1 && this.state.isCheckReport) {
            return this.jumpToReport(token);
        }
        this.jumpToManage(token, 0);
    }

    /**
     * 轮询登录
     */
    loginScroll(){
        clearTimeout(this.setTimeout);
        clearInterval(this.interval);
        // 账号密码登录无需轮询扫码状态
        if(this.state.loginType != 'scan') return;
        this.setTimeout = setTimeout(() => {
            clearInterval(this.interval);
        }, 1000 * 600);
        this.interval = setInterval(() => {
            // scanType 1登录 2注册 
            let params = { scanToken: this.state.token, scanType: 1 };
            if(Number(this.state.platformType) == 1){
                // GCRP
                Server.gcrpScanPolling(params);
            }else{
                // CRP
                Server.crpScanPolling(params);
            }
        }, 1000 * 2);
    }

    /**
     *  切换平台
     */
    standardOnChange = (value, key) => {
        this.setState({ 
            [key]: value,
            token: `${Number(value)==1?'webManage':'pcCrp'}${Util.randomWord(false, 32)}`,        //token
            loginType: 'scan',                              //默认优先使用微信扫码
            authType: 1,                                    //GCRP仅支持手机号
            scanCodeStatus: false,
        },()=>{
            this.props.form.resetFields();
            this.loginScroll()
        });
    }

    /**
     * 切换登录方式（账号密码 / 微信扫码）
     */
    changeLoginType = (loginType) => {
        this.setState({
            loginType,
            scanCodeStatus: false,
            //重新生成token，避免复用已失效的token
            token: `${Number(this.state.platformType)==1?'webManage':'pcCrp'}${Util.randomWord(false, 32)}`,
        },()=>{
            this.loginScroll()
        });
    }

    /**
     * 切换认证类型
     */
    handleAuthTypeChange = (e) => {
        this.setState({ authType: e.target.value });
        this.props.form.resetFields(['account']);
    }

    /**
     * 账号输入框是否为手机号（GCRP 仅支持手机号）
     */
    isPhoneAccount = () => {
        return this.state.platformType==1 || this.state.authType==1;
    }

    /**
     * 账号输入框校验规则
     */
    getAccountRules = () => {
        if(this.isPhoneAccount()) {
            return [
                { required: true, message: '请输入手机号' },
                { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号' },
            ];
        }
        return [
            { required: true, message: '请输入邮箱' },
            { type: 'email', message: '请输入正确的邮箱格式' },
        ];
    }

    /**
     * 提交账号密码登录
     */
    handlePasswordLogin = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if(err) return;
            // scanToken 与扫码登录方式一致
            let params = {
                password: values.password,
                scanToken: this.state.token,
            };
            this.setState({ submitting: true });
            if(Number(this.state.platformType) == 1){
                // GCRP 仅支持手机号
                params.userPhone = values.account;
                Server.gcrpPasswordLogin(params);
                return;
            }
            params.authType = this.state.authType;
            if(this.state.authType == 1){
                params.userPhone = values.account;
            }else{
                params.userEmail = values.account;
            }
            Server.crpPasswordLogin(params);
        });
    }

    handleCheck = (e) => {
        this.setState({
            isCheckReport: e.target.checked
        })
    }

    /**
     * 点击切换路径
     */
    changeSrcAction = () => {
        let tabNumber = this.state.tabNumber + 1;
        this.setState({
            tabNumber,
        },()=>{
            if(this.state.tabNumber>4){
                let _this = this;
                confirm({
                    title: '是否确定切换本地调试',
                    okType: 'danger',
                    onOk() {
                        _this.setState({ isTab: 1 })
                    },
                    onCancel() {
                        _this.setState({ isTab: 2 })
                    },
                  });
            }
            this.setTimeoutTab = setTimeout(()=>{
                this.setState({ tabNumber: 0 });
            },2000)
        })
    }

    /**
     * 微信扫码登录
     */
    renderScanLogin() {
        return (
            <div>
                <div className='loginQrCodeTitle'>为了保障账户安全，请使用微信扫码验证身份</div>
                <div className='qrCodeBox'>
                    {this.state.platformType == 1?<QRcode value={`${BASE_URL}/webGcrpManage/wxLogin?platformType=3&type=1&skey=${this.state.token}&groupName=${manageConfig.groupName}&isReport=${this.state.isCheckReport}`} size={200} />:<QRcode value={`${BASE_URL}/publicApi/wxPcLogin?platformType=1&type=1&skey=${this.state.token}&groupName=${manageConfig.groupName}`} size={200} />}
                </div>
                <div className='qrCodeTip' hidden={!this.state.scanCodeStatus}>
                    <p className='lineDiv'>
                        <Icon type="check-circle" theme="filled" style={{color: '#59CC79',fontSize:'16px',marginRight:'8px'}} />
                        <p>扫码成功</p>
                    </p>
                    <p>请在微信上进行后续操作</p>
                </div>
                {
                    this.state.platformType == '1' && <div className='report-data'>
                    <Checkbox onChange={this.handleCheck} checked={this.state.isCheckReport}>登录集团数据报表</Checkbox>
                </div>
                }
                <div className='loginTypeSwitch'>
                    <a onClick={() => this.changeLoginType('password')}>账号密码登录</a>
                </div>
            </div>
        );
    }

    /**
     * 账号密码登录
     */
    renderPasswordLogin() {
        const { getFieldDecorator } = this.props.form;
        const isPhone = this.isPhoneAccount();
        return (
            <div className='pwdLoginBox'>
                <div className='pwdLoginTitle'>账号密码登录</div>
                {
                    this.state.platformType != 1 && <div className='pwdAuthTypeBox'>
                    <Radio.Group value={this.state.authType} onChange={this.handleAuthTypeChange}>
                        <Radio value={1}>手机号登录</Radio>
                        <Radio value={2}>邮箱登录</Radio>
                    </Radio.Group>
                </div>
                }
                <Form className='pwdForm' onSubmit={this.handlePasswordLogin}>
                    <FormItem>
                        {getFieldDecorator('account', { rules: this.getAccountRules() })(
                            <Input
                                size="large"
                                prefix={<Icon type={isPhone?'mobile':'mail'} />}
                                placeholder={isPhone?'请输入手机号':'请输入邮箱'}
                                autoComplete="off" />
                        )}
                    </FormItem>
                    <FormItem>
                        {getFieldDecorator('password', { rules: [
                            { required: true, message: '请输入密码' },
                            { min: 6, message: '密码至少6位' },
                            { max: 20, message: '密码最多20位' },
                        ] })(
                            <Input.Password
                                size="large"
                                prefix={<Icon type="lock" />}
                                placeholder="请输入密码（6-20位）"
                                autoComplete="off" />
                        )}
                    </FormItem>
                    <FormItem>
                        <Button type="primary" htmlType="submit" className='pwdSubmitBtn' loading={this.state.submitting} block>登录</Button>
                    </FormItem>
                </Form>
                {
                    this.state.platformType == '1' && <div className='report-data pwdReportData'>
                    <Checkbox onChange={this.handleCheck} checked={this.state.isCheckReport}>登录集团数据报表</Checkbox>
                </div>
                }
                <div className='pwdTips'>
                    <p>温馨提示：</p>
                    <p>1. 密码为6-20位字符</p>
                    <p>2. 账号锁定后请30分钟后重试</p>
                    <p>3. 如有问题请联系管理员</p>
                </div>
                <div className='loginTypeSwitch'>
                    <a onClick={() => this.changeLoginType('scan')}>微信扫码登录</a>
                </div>
            </div>
        );
    }

    render() {
        const isPasswordLogin = this.state.loginType == 'password';
        return (
            <div className='baseBox'>
                <Row className='loginHeader'>
                    <img className='logoImg' src={manageConfig.mainLogo} />
                </Row>
                <Layout className='loginLayout'>
                    <Content className='loginContent'>
                        <div className={isPasswordLogin?'loginQrCodeBox loginPwdBox':'loginQrCodeBox'} style={(!isPasswordLogin && this.state.scanCodeStatus)?{height: '440px'}:{}}>
                            {
                                this.state.isNew != 1 && 
                                <Tabs 
                                className="login_tabs"
                                tabBarGutter={0} 
                                hidden={this.state.scanCodeStatus} 
                                animated={false} 
                                onChange={(e) => this.standardOnChange(e, 'platformType')} 
                                activeKey={this.state.platformType+''}>
                                <TabPane tab="集团入口(GCRP)" key="1"></TabPane>
                                <TabPane tab="商圈入口(CRP)" key="2"></TabPane>
                            </Tabs>
                            }
                            {isPasswordLogin ? this.renderPasswordLogin() : this.renderScanLogin()}
                        </div>
                        
                    </Content>
                    <Footer className='loginFooter'><a className='loginFooter' href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank"> 粤ICP备14013572号</a><br/><span className='loginFooter' onClick={this.changeSrcAction} style={this.state.isTab==1?{color: '#F8B62C'}:{}}>woxshare © {new Date().getFullYear()}沃享科技</span></Footer>
                </Layout>
            </div>
        );
    }

}

export default Form.create()(DownloadManage);


// WEBPACK FOOTER //
// ./src/container/login.js